import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import {
    changeCopiedRetargetingRulesTooltipStatus,
    copyRetargetingRulesInfoToClipboard
} from '../../actions/grid-screen';
import {
    RetargetingRulesInfo,
    RetargetingRulesInfoProps
} from '../../components/RetargetingRulesInfo/RetargetingRulesInfo';
import {
    CopyTooltipStatus,
    RetargetingConditionRule
} from '../../typings/domain';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type StateProps = TStateProps<RetargetingRulesInfoProps>;
type DispatchProps = TDispatchProps<RetargetingRulesInfoProps>;

export type OwnProps = {
    conditionRules: RetargetingConditionRule[];
};

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { copyTooltipStatus } = state.grid.retargetingRulesInfo;

    return {
        ...ownProps,
        copyTooltipStatus
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onCopy: (text: string) => {
            dispatch(copyRetargetingRulesInfoToClipboard(text));
        },
        onPopupOpen: () => {
            dispatch(
                changeCopiedRetargetingRulesTooltipStatus(
                    CopyTooltipStatus.hidden
                )
            );
        }
    };
};

export const RetargetingRulesInfoContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps
>(
    mapStateToProps,
    mapDispatchToProps
)(RetargetingRulesInfo);
